@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.button-container {
  display: inline-flex;
  position: relative;
}

.process-shipments-button {
  margin-left: 10px;
}

.button-styles {
  font-size: 14px;
  border-right: 1px solid var(--white);
  display: flex;

  &:disabled {
    border-right: 1px solid var(--gray-8D9196);
  }
}

.drop-down-menu-button {
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  svg {
    fill: var(--white);
  }

  &:disabled {
    svg {
      fill: var(--gray-8D9196);
    }
  }
}

.dropdown-menu {
  max-width: none;
}
